<template lang="pug">
  .refund-order-container
    .list-items.form.refund-order-row
      .item-refund.capitalize.refund-order-id.pointer(@click="goToRefund") {{ refund.refund }}
      .item-refund.capitalize {{ refundTypeLabel(refund.type) }}
      .item-refund.capitalize {{ text.states[refund.status] }}
      .item-refund {{ refund.method }}
      .item-refund {{ money(refund.value) }}
      .item-refund {{ dateTime(refund.createdAt) }}
      shExpandButton.line(@click.native.stop="show = !show" :expand="show")

    transition(name="slide-fade")
      div(v-if="show")
        h3(v-if="refund.observations && refund.observations.length") Observations
        .observation.list-items(v-for="(observation, index) in refund.observations" :key="observation.createdAt")
          .observation-observation {{ index + 1 }}. {{ observation.observation }}
          div {{ dateTime(observation.createdAt) }}
          shNameUser(:dni="observation.createdBy")

        .input-container
          input.input(v-model="refund.account" autocomplete="ño" disabled)
          label.label.capitalize(:class="{ show: refund.account }") Número de cuenta

        .input-container.arrow
          select.select(v-model="refund.accountType" autocomplete="ño" disabled)
            option(value="")
            option(value="0") Ahorros
            option(value="1") Corriente
          label.label.capitalize(:class="{ show: refund.accountType }") Tipo de Cuenta
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import shExpandButton from '@/components/elements/ExpandButton'
import shNameUser from '@/components/elements/NameUser'
import shInputList from '@/components/elements/InputList'
import router from '@my/router'

export default {
  name: 'Refund',

  components: { shExpandButton, shNameUser, shInputList },

  mixins: [mFilters, mForm],

  props: {
    refund: Object,
    text: Object
  },

  data () {
    return {
      show: false,
      observations: [],
      observation: '',
      types: [
        { key: '0', value: 'Derecho al rectracto (aplica hasta 5 días después de que le llegó el producto)' },
        { key: '1', value: 'El pedido llegó tarde' },
        { key: '2', value: 'El pedido no llegó' },
        { key: '3', value: 'No le gustó los productos' },
        { key: '4', value: 'No le quedaron los productos' },
        { key: '5', value: 'Producto fuera de stock' },
        { key: '6', value: 'Envió dinero de más' },
        { key: '7', value: 'Devolución de propina' },
        { key: '8', value: 'El producto llegó dañado o defectuoso' },
        { key: '20', value: 'Solicitud cliente (transferencia)' }
      ]
    }
  },

  methods: {
    refundTypeLabel (type) {
      if (type == null || type === '') return '—'
      const row = this.types.find((t) => String(t.key) === String(type))
      return row ? row.value : String(type)
    },

    goToRefund () {
      if (!this.refund || !this.refund.refund) return
      router.goToRefunds({ refund: this.refund.refund })
    }
  }
}
</script>

<style lang="stylus">
.refund-order-container
  border-bottom 1px solid var(--color-border-items)
  border-radius 1em

.refund-order-id
  text-decoration underline
  text-underline-offset 0.12em
</style>



// WEBPACK FOOTER //
// src/components/pages/order/Refund.vue